<template>
  <div class="workOrders">
    <div class="head-box">
      <div class="c-flex c-flex-item">
        <h4>
          售后工单
        </h4>
        <el-dropdown
          v-if="
            osg.has('WorkOrders,all') ||
              osg.has('WorkOrders,todo') ||
              osg.has('WorkOrders,done') ||
              osg.has('WorkOrders,my') ||
              osg.has('WorkOrders,concern') ||
              osg.has('WorkOrders,archived')
          "
          style="min-width:90px;"
          @command="
            orderState => {
              this.orderState = orderState;
              this.fpi.page = 1;
              this.getData();
            }
          "
        >
          <span class="c_blue">
            {{
              orderState == 'my'
                ? '我创建的'
                : orderState == 'concern'
                ? '关注的'
                : orderState == 'todo'
                ? '待办'
                : orderState == 'done'
                ? '已办'
                : orderState == 'archived'
                ? '已归档'
                : '全部'
            }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="osg.has('WorkOrders,all')" command="all">
              全部
            </el-dropdown-item>
            <el-dropdown-item v-if="osg.has('WorkOrders,todo')" command="todo">
              待办
            </el-dropdown-item>
            <el-dropdown-item v-if="osg.has('WorkOrders,done')" command="done">
              已办
            </el-dropdown-item>
            <el-dropdown-item v-if="osg.has('WorkOrders,my')" command="my">
              我创建的
            </el-dropdown-item>
            <el-dropdown-item v-if="osg.has('WorkOrders,concern')" command="concern">
              我关注的
            </el-dropdown-item>
            <el-dropdown-item v-if="osg.has('WorkOrders,archived')" command="archived">
              已归档
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span v-else class="c_blue f-s-14">
          {{
            orderState == 'my'
              ? '我创建的'
              : orderState == 'concern'
              ? '关注的'
              : orderState == 'todo'
              ? '待办'
              : orderState == 'done'
              ? '已办'
              : orderState == 'archived'
              ? '已归档'
              : '全部'
          }}
        </span>
      </div>
      <div class="c-flex c-flex-item">
        <el-date-picker
          v-model="searchDate"
          type="datetimerange"
          :picker-options="date.pickerOptions"
          start-placeholder="创建开始日期"
          end-placeholder="创建结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
        ></el-date-picker>
        <el-input
          placeholder="请输入标题/工单编号/姓名/手机/地址/描述"
          v-model="searchValue"
          style="width: 335px;margin-left:10px;"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button
          v-if="
            (!orderState ||
              orderState == 'my' ||
              orderState == 'concern' ||
              osg.has('WorkOrders?orderState=todo,new') ||
              osg.has('WorkOrders?orderState=done,new')) &&
              tenantId != '4551453470943235290'
          "
          type="primary"
          @click="doNew"
          class="c-m-l-10"
        >
          新建售后工单
        </el-button>
        <el-dropdown class="c-m-l-10" v-if="osg.has('WorkOrders,import')">
          <el-button type="primary">
            数据导出
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="
                osg.doExport(
                  {
                    'in:state|integer#and': orderState == 'archived' ? -1 : 1,
                    'in:concernUserIds|array#and': orderState == 'concern' ? user._id : null,
                    'fpi-notFilterBelongTo': orderState == 'concern' ? '1' : null,
                    'fpi-notFilterOrgId': orderState == 'concern' ? '1' : null,
                    'gte:createTime|date#and': searchDate[0],
                    'lte:createTime|datetime#and': searchDate[1],
                    'fpi-regex:name|string#or': searchValue,
                    'fpi-regex:title|string#or': searchValue,
                    'fpi-regex:phone|string#or': searchValue,
                    'fpi-regex:orderNum|string#or': searchValue,
                    'fpi-regex:address|string#or': searchValue,
                    beanName: 'workOrder',
                    title: '售后工单列表'
                  },
                  { dynamic: true }
                )
              "
            >
              导出列表字段
            </el-dropdown-item>
            <el-dropdown-item
              @click.native="
                osg.doExport(
                  {
                    'in:state|integer#and': orderState == 'archived' ? -1 : 1,
                    'in:concernUserIds|array#and': orderState == 'concern' ? user._id : null,
                    'fpi-notFilterBelongTo': orderState == 'concern' ? '1' : null,
                    'fpi-notFilterOrgId': orderState == 'concern' ? '1' : null,
                    'gte:createTime|date#and': searchDate[0],
                    'lte:createTime|datetime#and': searchDate[1],
                    'fpi-regex:name|string#or': searchValue,
                    'fpi-regex:title|string#or': searchValue,
                    'fpi-regex:phone|string#or': searchValue,
                    'fpi-regex:orderNum|string#or': searchValue,
                    'fpi-regex:address|string#or': searchValue,
                    beanName: 'workOrder',
                    title: '售后工单列表'
                  },
                  { dynamic: true, importFields: true }
                )
              "
            >
              导出模板字段
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          v-else-if="
            osg.has('WorkOrders,export') ||
              osg.has('WorkOrders?orderState=archived,export') ||
              osg.has('WorkOrders?orderState=concern,export')
          "
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|integer#and': orderState == 'archived' ? -1 : 1,
                'in:concernUserIds|array#and': orderState == 'concern' ? user._id : null,
                'fpi-notFilterBelongTo': orderState == 'concern' ? '1' : null,
                'fpi-notFilterOrgId': orderState == 'concern' ? '1' : null,
                'gte:createTime|date#and': searchDate[0],
                'lte:createTime|datetime#and': searchDate[1],
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:title|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:orderNum|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                beanName: 'workOrder',
                title: '售后工单列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-button
          v-if="osg.has('WorkOrders,import')"
          type="primary"
          class="c-m-l-10"
          @click="osg.open('Import', { colName: 'workOrder' }, '_blank')"
        >
          数据导入
        </el-button>
        <el-button
          v-if="osg.has('WorkOrders,expurgate')"
          type="primary"
          class="c-m-l-10"
          @click="batchExpurgate"
        >
          归档
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          height="calc(100% - 50px)"
          :data="fpi.data"
          style="width: 100%"
          v-show="refresh"
          ref="table"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          @selection-change="selectionChange"
        >
          <!--        多选框功能：1.增加多选框的一列，需要在《el-table》标签头里面加入：@selection-change="selectionChange" ，表示点击多选框时调用的函数     -->
          <el-table-column
            v-if="osg.has('WorkOrders,expurgate')"
            type="selection"
            fixed
            width="55"
          ></el-table-column>
          <c-table :fields="extFields" :options="options" dataPath="data">
            <!-- TODO: -->
            <template slot="phone">
              <el-table-column prop="data.phone" label="客户电话" width="120px">
                <template slot-scope="scope">
                  <div
                    v-if="
                      scope.row.data.phone ||
                        (tenantId != '1340835581184723420' &&
                          (osg.tenantConfig && osg.tenantConfig.privateNumber != 1))
                    "
                  >
                    {{ scope.row.data.phone }}
                  </div>
                  <template v-else>
                    <el-popover
                      placement="top-start"
                      trigger="click"
                      :content="privateNumber.phone"
                    >
                      <el-button
                        slot="reference"
                        size="mini"
                        @click="
                          osg.getPrivateNumber(
                            '1',
                            null,
                            scope.row.data.contactIds[0],
                            scope.row.data._id
                          )
                        "
                      >
                        查看中间号
                      </el-button>
                    </el-popover>
                  </template>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <template v-if="orderState != 'archived'">
                    <el-dropdown-item
                      v-if="
                        osg.has('WorkOrders,edit') ||
                          osg.has('WorkOrders?orderState=my,edit') ||
                          osg.has('WorkOrders?orderState=concern,edit') ||
                          osg.has('WorkOrders?orderState=todo,edit') ||
                          osg.has('WorkOrders?orderState=done,edit')
                      "
                      @click.native="doEdit(scope.row.data)"
                    >
                      编辑
                    </el-dropdown-item>
                    <el-popover
                      placement="left"
                      width="400"
                      v-if="osg.has('WorkOrders,excelEditor')"
                    >
                      <el-table :data="documentTemplates">
                        <el-table-column
                          property="name"
                          label="文档名称"
                          show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column fixed="right" width="140px">
                          <template slot-scope="scopeItem">
                            <el-button
                              size="mini"
                              type="primary"
                              @click.native="
                                osg.excelEditor(
                                  'workOrder',
                                  scopeItem.row._id,
                                  scope.row.data._id,
                                  scope.row.data.exts && scope.row.data.exts.workflowDefId
                                )
                              "
                            >
                              使用此模板打印
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-dropdown-item
                        slot="reference"
                        @click.native="
                          osg.getDocumentTemplates(
                            'workOrder',
                            scope.row.data._id,
                            scope.row.data.exts && scope.row.data.exts.workflowDefId
                          )
                        "
                      >
                        打印
                      </el-dropdown-item>
                    </el-popover>

                    <el-dropdown-item
                      v-if="osg.has('WorkOrders,urged')"
                      @click.native="readyAlert(scope.row.data)"
                    >
                      催办
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('WorkOrders,able') && scope.row.state == 0"
                      @click.native="doEnable(scope.row.data && scope.row.data._id)"
                    >
                      启用
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('WorkOrders,able') && scope.row.state == 1"
                      @click.native="doDisable(scope.row.data && scope.row.data._id)"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('WorkOrders,close') && scope.row.status != 'closed'"
                      @click.native="doClose(scope.row.data)"
                    >
                      关闭工单
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('WorkOrders,archive')"
                      @click.native.prevent="doArchive(scope.row.data, '归档', 1)"
                    >
                      归档
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        orderState == 'todo' &&
                          scope.row.nodeDef &&
                          (scope.row.nodeDef.nodeType == 'allot' ||
                            scope.row.nodeDef.nodeTypeOld == 'allot')
                      "
                      @click.native="openSR(scope.row)"
                      divided
                    >
                      分单
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        orderState == 'todo' &&
                          scope.row.nodeDef &&
                          (scope.row.nodeDef.nodeType == 'dispatch' ||
                            scope.row.nodeDef.nodeTypeOld == 'dispatch')
                      "
                      @click.native="openSR(scope.row)"
                      divided
                    >
                      派单
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        orderState == 'todo' &&
                          scope.row.nodeDef &&
                          scope.row.nodeDef.nodeType == 'accept'
                      "
                      @click.native="accept(scope.row)"
                      divided
                    >
                      接单
                    </el-dropdown-item>
                    <template
                      v-if="
                        osg.has('WorkOrders,reassign') && !orderState && btnShow(scope.row.data)
                      "
                    >
                      <template
                        v-for="(item, i) of scope.row.data && scope.row.data.workflowNodeList"
                      >
                        <el-dropdown-item
                          :key="i"
                          v-if="
                            i != 0 && available(item, scope.row.data && scope.row.data.createUser)
                          "
                          @click.native="openSR(scope.row.data, item)"
                          divided
                        >
                          重新{{ item.nodeDef.name }}
                        </el-dropdown-item>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    <el-dropdown-item
                      v-if="osg.has('WorkOrders?orderState=archived,recover')"
                      @click.native.prevent="doArchive(scope.row.data, '恢复', 2)"
                    >
                      恢复
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="售后工单"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="110px"
        :area="area"
        @changeForm="osg.changeForm"
      >
        <template slot="inventoryId">
          <template v-if="formData._id">
            <el-input v-model="formData.exts.warrantyProductName" disabled></el-input>
          </template>
          <template v-else>
            <el-select
              v-model="formData.exts.inventoryId"
              @change="handleInventoryIdSelect"
              placeholder="请选择"
              clearable
              filterable
            >
              <el-option
                v-for="item in options.warrantyProductInventorys"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              >
                <template :slot-scope="{ item }">
                  <p class="c-flex c-flex-between">
                    <span>{{ item.name }}</span>
                    <span>{{ item.inventoryCode }}</span>
                  </p>
                </template>
              </el-option>
            </el-select>
          </template>
        </template>
        <template slot="title21" v-if="tenantId == '4551453470943235290'">
          <el-input
            :disabled="formData._id"
            v-model="formData.exts['title21']"
            type="number"
            :placeholder="formData.placeholder || '请输入'"
          >
            <el-button
              slot="append"
              style="font-size: 28rpx;"
              @click="addBdBucketCodes('pushItem', 'title21')"
              size="small"
              :disabled="formData._id"
              type="danger"
            >
              手工输入产品码
            </el-button>
          </el-input>
          <template v-if="!formData._id">
            <template v-for="(bdCodeItem, bdKey) in formData.exts.bdBucketCodes">
              <div v-for="(iItem, iIndex) in bdCodeItem" :key="iIndex" class="bdPCode-wrapper">
                <span>{{ osg.codelabel('productBizType', bdKey) }}</span>
                <span>{{ iItem.substr(iItem.indexOf('fw=') + 3) }}</span>
                <!-- <i
                  class="el-icon-delete"
                  @click="bdPCodeDelete(bdCodeItem, iIndex, formData.exts.bdBucketCodes, bdKey)"
                ></i> -->
              </div>
            </template>
          </template>
        </template>
        <template slot="name">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="formData.name"
            :fetch-suggestions="querySearch"
            placeholder="请输客户名称"
            @select="handleSelect"
            hide-loading
            value-key="name"
            @input="changeName"
            :disabled="
              extFields.some(
                fiel =>
                  fiel.name == 'name' &&
                  (fiel.operationType == '2'
                    ? true
                    : fiel.operationType == '3'
                    ? formData._id
                      ? true
                      : false
                    : false)
              )
            "
          >
            <i class="el-icon-search el-input__icon"></i>
            <template slot-scope="{ item }">
              <p class="c-flex c-flex-between">
                <span>{{ item.name }}</span>
                <span>{{ item.phone }}</span>
              </p>
            </template>
          </el-autocomplete>
        </template>
        <template slot="phone">
          <!-- 中间号 -->
          <el-popover
            v-if="privateNumber.show"
            placement="top-start"
            trigger="click"
            :content="privateNumber.phone"
          >
            <el-button
              slot="reference"
              class="c-w-1"
              @click="
                osg.getPrivateNumber(
                  '1',
                  null,
                  formData.contactIds && formData.contactIds[0],
                  formData._id
                )
              "
            >
              查看中间号
            </el-button>
          </el-popover>
          <el-input
            v-model="formData.phone"
            :disabled="
              extFields.some(
                fiel =>
                  fiel.name == 'phone' &&
                  (fiel.operationType == '2'
                    ? true
                    : fiel.operationType == '3'
                    ? formData._id
                      ? true
                      : false
                    : false)
              )
            "
            v-else
          ></el-input>
        </template>
        <template slot="landlineNumber">
          <!-- 中间号 -->
          <el-popover
            v-if="
              privateNumber.show &&
                (formData.exts.landlineNumber == '10000' || formData.exts.landlineNumber == '9999')
            "
            placement="top-start"
            trigger="click"
            :content="privateNumber.phone"
          >
            <el-button
              slot="reference"
              class="c-w-1"
              @click="
                osg.getPrivateNumber(
                  '8',
                  null,
                  formData.contactIds && formData.contactIds[0],
                  formData._id
                )
              "
            >
              查看中间号
            </el-button>
          </el-popover>
          <el-input v-model="formData.exts.landlineNumber" v-else></el-input>
        </template>
        <template slot="area" v-if="tenantId != '4363416483534256239'">
          <el-cascader
            popper-class="cascaderLabelHide-wrapper"
            ref="areaSelector"
            :options="area.options"
            :props="{
              checkStrictly: false,
              expandTrigger: 'hover'
            }"
            v-model="formData.area"
            clearable
            @change="
              if (formData.subdistrict) {
                formData.subdistrict = '';
              }
              osg.getSubdistricts(formData.area, result => {
                options.subdistricts = result;
                $forceUpdate();
              });
            "
          ></el-cascader>
        </template>
        <template></template>
        <template slot="address">
          <el-input
            v-model="formData.address"
            suffix-icon="el-icon-map-location"
            @blur="getGeocode"
          ></el-input>
        </template>
        <!-- TODO:闭水用到了 -->
        <!-- <el-form-item label="工作类型" v-if="tenantId == '4551453470943235290'">
          <el-select v-model="formData.workType">
            <el-option
              v-for="item in options.workType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <template slot="channel">
          <el-cascader
            clearable
            v-model="formData.channel"
            :options="options.channel"
            :props="{ expandTrigger: 'hover', label: 'name' }"
          ></el-cascader>
        </template>
        <!-- <el-form-item label="获客渠道" v-if="formData.channelId">
          <el-select v-model="formData.channelId" :disabled="true">
            <el-option
              v-for="item in options.channelId"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="服务资源"
      :visible.sync="SR.show"
      custom-class="c-dialog"
      @close="cancelSR"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="c-flex c-flex-end">
        <el-select
          v-if="SR.nodeType == 'allot'"
          v-model="SR.ids"
          placeholder="搜索服务区域"
          class="screen"
          clearable
          filterable
          remote
          :remote-method="getServiceTerritory"
          @clear="
            SR.fpi.page = 1;
            getServiceTerritory();
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            SR.selectId = '';
            SR.selectRow = {};
            getSR();
          "
        >
          <el-option
            v-for="(item, i) in options.serviceTerritory"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="SR.resourceType"
          multiple
          placeholder="筛选资源类型"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <template v-for="item in options.resourceType">
            <el-option
              :key="item.value"
              :label="item.label"
              :value="item.value"
              v-if="
                !SR.nodeType ||
                  (SR.nodeType == 'allot' &&
                    (item.value == 'partner' || item.value == 'serviceCrew')) ||
                  (SR.nodeType == 'dispatch' &&
                    item.value != 'partner' &&
                    item.value != 'serviceCrew')
              "
            ></el-option>
          </template>
        </el-select>
        <el-select
          v-model="SR.resourceRoles"
          multiple
          placeholder="筛选资源角色"
          class="screen"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @change="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <template v-for="item in options.resourceRoles">
            <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
          </template>
        </el-select>
        <el-input
          placeholder="请输入资源名称"
          v-model="SR.searchValue"
          class="search-input c-fr"
          clearable
          @clear="
            SR.fpi.page = 1;
            getSR();
          "
          @keyup.enter.native="
            SR.fpi.page = 1;
            getSR();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              SR.fpi.page = 1;
              getSR();
            "
          ></el-button>
        </el-input>
      </div>
      <el-table
        v-loading="SR.loading"
        :data="SR.fpi.data"
        height="100%"
        style="width: 100%; min-height: 440px"
        fit
        header-row-class-name="c-black-dark"
        highlight-current-row
        @current-change="selectSR"
      >
        <el-table-column label="选择" width="50px;">
          <template slot-scope="scope">
            <el-radio v-model="SR.selectId" :label="scope.row._id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column
          prop="resourceType"
          label="资源类型"
          :formatter="formatSRType"
        ></el-table-column>
        <el-table-column label="资源">
          <template slot-scope="scope">
            <template
              v-if="scope.row.resourceType == 'partner' || scope.row.resourceType == 'serviceCrew'"
            >
              {{ formatOrg(scope.row.serviceCrewId) }}
            </template>
            <template v-else>
              {{ formatUser(scope.row.relatedRecordId) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop="_id"
          label="服务区域"
          :formatter="formatST"
          v-if="SR.nodeType == 'allot'"
        ></el-table-column>
        <el-table-column prop="lastKnownLocation" label="最新位置"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="SR.fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="SR.fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="SR.fpi.total"
        ></el-pagination>
        <div class="c-flex">
          <el-button type="primary" @click="saveSR">确 定</el-button>
          <el-button @click="cancelSR">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="催办"
      :visible.sync="workflowAlert"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="c-dialog"
    >
      <el-form
        :model="workflowAlertData"
        :rules="rules"
        ref="workflowAlertData"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="催办类型" prop="type">
          <!-- <el-input v-model="workflowAlertData.type"></el-input> -->
          <el-select v-model="workflowAlertData.type1Type" placeholder="请选择类型">
            <el-option
              v-for="item in options.workflowAlert"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="被催办人" prop="handlerIds">
          <el-select
            multiple
            v-model="workflowAlertData.handlerIds"
            placeholder="请选择待办人"
            clearable
            filterable
          >
            <el-option
              v-for="item in alertUser"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="催办备注" prop="memo">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入给处理人的备注信息"
            v-model="workflowAlertData.memo"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-table :data="alertTableData" style="width: 100%">
        <el-table-column
          prop="type1Type"
          label="催办类型"
          min-width="80"
          :formatter="formatType1Type"
        ></el-table-column>
        <el-table-column prop="createTime" label="发起时间" min-width="100"></el-table-column>
        <el-table-column prop="workflowNodeName" label="催办节点" min-width="80"></el-table-column>
        <el-table-column prop="handleUserName" label="处理人" min-width="100"></el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          min-width="80"
          :formatter="formatAltertState"
        ></el-table-column>
        <el-table-column prop="memo" label="催办备注" min-width="180"></el-table-column>
        <el-table-column fixed="right" min-width="90" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.callId"
              @click.native.prevent="viewCallRecord(scope.row.callId)"
              size="mini"
            >
              查看录音
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="saveAlert">提交新催办</el-button>
        <el-button @click="sendAlert">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="通话录音"
      :visible.sync="callRecording"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="c-dialog"
      @close="callRecordingData = {}"
    >
      <div class="box-center-content" style="border: 1px solid #ccc; border-radius: 6px">
        <div class="activity-card">
          <div class="activity-card-header">
            <span class="c-font-500">
              <i class="el-icon-phone-outline c-w-30"></i>
              <span v-if="callRecordingData.callDirection == '0'">呼入</span>
              <span v-else-if="callRecordingData.callDirection == '1'">呼出</span>
            </span>
            <span>{{ osg.codelabel('callResult', callRecordingData.callResult) }}</span>
          </div>
          <div class="activity-card-content">
            <div>
              主叫：{{ callRecordingData.callerName }}
              {{ callRecordingData.caller }}
            </div>
            <div>
              被叫：{{
                callRecordingData.callWay == 4
                  ? callRecordingData.calleeName || ''
                  : callRecordingData.callDirection == '0'
                  ? callRecordingData.calleeName || ''
                  : callRecordingData.calleeName || formData.name || ''
              }}{{ ' ' + callRecordingData.callee }}
            </div>
            <div>
              通话时间：{{ callRecordingData.startTimeStr }} 至
              {{ callRecordingData.endTimeStr }}
            </div>
            <audio
              v-if="callRecordingData.recordUrl"
              class="c-m-t-15 w-1"
              controls
              :src="callRecordingData.recordUrl"
            >
              您的浏览器不支持 audio 标签。
            </audio>
          </div>
          <div class="activity-card-footer">
            <!-- <span>操作人：{{ item.createUserName }}</span> -->
            <span></span>
            <span>生成记录时间：{{ callRecordingData.createTime }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="callRecording = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
// import areaList from '../../resources/js/areaList4.js';
export default {
  name: 'WorkOrders',
  props: {
    serviceState: {
      type: String
    },
    //通话记录id
    callId: {
      type: String
    }
  },
  data() {
    window.$this = this;
    return {
      selectedList: [],
      tenantId: '',
      refresh: true,
      name: 'workOrder',
      state: '', //已归档 archive
      orderState: '', //全部售后工单 待办售后工单 已办售后工单
      multipleSelection: [], //多选
      fpi: {},
      searchValue: '',
      searchDate: [],
      openDetail: false,
      callRecording: false, //通话录音弹窗
      formData: {
        name: '',
        phone: '',
        address: '',
        exts: { newAddress: '' },
        gpsPoint: {}
      },
      extFields: [],
      extFieldsData: [], //动态列表用到
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      options: {
        channelId: [],
        cascadeCode_channel: { codeId: 'channel' },
        // codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_channelId: { codeId: 'channelId' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        codecfg_altertState: { codeId: 'altertState' },
        codecfg_callResult: { codeId: 'callResult' },
        codecfg_productBizType: { codeId: 'productBizType' }, //闭水产品业务类型
        //服务资源
        codecfg_resourceType: {
          codeId: 'resourceType'
        },
        codecfg_resourceRoles: {
          codeId: 'resourceRoles'
        },
        codecfg_workflowAlert: {
          codeId: 'workflowAlert'
        },
        subdistricts: []
      },
      rules: this.$util.rules,
      //地址级联-懒加载
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      //当前行工作流节点
      currentWorkflow: {},
      //分单（分服务资源）
      SR: {
        show: false,
        fpi: {},
        selectRow: {},
        selectId: '',
        searchValue: '',
        ids: [], //选择服务区域筛选出的关联的服务资源id
        resourceType: [], //筛选服务资源类型
        resourceRoles: [], //筛选资源角色
        nodeType: '', //当前节点类型
        loading: false //表格数据加载
      },
      //派单（分服务资源）
      user: {
        show: false,
        fpi: {},
        selectRow: {},
        selectId: ''
      },
      acountIds: [], //当前用户id 组织id 角色id
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      workflowAlert: false,
      workflowAlertData: {
        handlerIds: []
      },
      workflowAlerFpi: {},
      alertUser: {},
      alertTableData: [],
      callRecordingData: {}, //通话记录
      /**
       * 中间号
       */
      privateNumber: {
        show: false,
        phone: ''
      },
      //归档原因根据是否配置字段comments判断是否需要填写归档原因
      fillArchiveReason: false,
      /**
       * 文档模板
       */
      documentTemplates: []
    };
  },
  async mounted() {
    //当前用户id 组织id 角色id
    let account = JSON.parse(sessionStorage['loginAccount'] || sessionStorage['entity']);
    this.user = account;
    this.accountIds = account.roleIds.concat(account.orgIds);
    this.accountIds.push(account._id);
    this.tenantId = account.tenantId;
    this.orderState = this.osg.param('orderState');
    this.osg.getFpi();
    this.doInit();
  },
  methods: {
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    formatProvince(row, column, cellValue) {
      return this.osg.areaObj.province_list[cellValue];
    },
    formatCity(row, column, cellValue) {
      return this.osg.areaObj.city_list[cellValue];
    },
    formatDistrict(row, column, cellValue) {
      return this.osg.areaObj.county_list[cellValue];
    },
    formatStreet(row, column, cellValue) {
      return this.osg.areaObj.street_list[cellValue];
    },
    formatChannel(row, column, cellValue) {
      return this.osg.formatCascade('channel', cellValue);
    },
    formatChannelId(row, column, cellValue) {
      return this.osg.codelabel('channelId', cellValue);
    },
    formatWorkType(row, column, cellValue) {
      return this.osg.codelabel('workType', cellValue);
    },
    formatStage(row, column, cellValue) {
      return this.osg.codelabel('stage', cellValue);
    },
    formatStatus(row, column, cellValue) {
      return this.osg.codelabel('status', cellValue);
    },
    formatRole(row, column, cellValue) {
      return this.osg.codelabelForArray('role', cellValue);
    },
    formatSRType(row, column, cellValue) {
      return this.osg.codelabel('resourceType', cellValue);
    },
    formatST(row, column, cellValue) {
      return this.osg.codelabelInArray('ST', cellValue);
    },
    formatOrg(cellValue) {
      return this.osg.codelabel('org', cellValue);
    },
    formatUser(cellValue) {
      return this.osg.codelabel('users', cellValue);
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        name: '',
        phone: '',
        address: '',
        exts: { newAddress: '' },
        gpsPoint: {}
      };

      this.privateNumber = {
        show: false,
        phone: ''
      };
      if (this.$refs.formData) {
        this.$refs.formData.resetFields();
      }
      this.$util.renderExtField(this.extFields, this.formData);
      this.osg.getFields('workOrder', () => {
        //归档原因根据是否配置字段comments判断是否需要填写归档原因
        this.extFields = this.extFields.filter(item => {
          if (item.preset == 0 && item.name == 'comments') {
            if (this.orderState != 'archived') {
              this.fillArchiveReason = true;
              return false;
            }
          }
          return true;
        });
        if (this.serviceState) {
          if (this.$route.params.searchValue) {
            this.searchValue = this.$route.params.searchValue;
          }
          this.getData();
        } else {
          this.getData();
        }
        if (this.tenantId == '1340835581184723420') {
          this.getChannel();
        }
      });
    },
    //查询客户
    querySearch(queryString, cb) {
      var params = {
        page: 1,
        rows: 10,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#or': queryString,
        'regex:phone|string#or': queryString
      };
      this.osg.ajax(
        'basic/contacts/query.do',
        params,
        res => {
          cb(res.data);
        },
        { noload: true }
      );
    },
    //选择客户
    handleSelect(item) {
      let contactIds = this.formData.contactIds || [];
      contactIds.push(item._id);
      // this.$set(this.formData, 'contactIds', contactIds);
      this.$set(this.formData, 'phone', item.phone);
      this.$set(this.formData, 'area', item.area);
      this.$set(this.formData, 'address', item.address);
    },
    //根据售后工单客户姓名自动生成售后工单标题
    changeName(val) {
      // TODO:
      if (this.tenantId == '1340835581184723420') {
        this.$set(this.formData, 'title', val + '的售后工单' + this.$util.readableTime());
      } else if (this.tenantId == '4551453470943235290') {
        this.$set(this.formData, 'title', val + '的报单');
      }
    },
    pageSizeChange(pageSize) {
      if (this.SR.show) {
        this.SR.fpi.rows = pageSize;
        this.getSR();
      } else if (this.workflowAlert) {
        this.workflowAlerFpi.rows = pageSize;
        this.alertMsgList();
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.SR.show) {
        this.SR.fpi.page = currentPage;
        this.getSR();
      } else if (this.workflowAlert) {
        this.workflowAlerFpi.rows = currentPage;
        this.alertMsgList();
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    //获取售后工单列表
    getData() {
      this.searchDate = this.searchDate || [];
      // TODO:
      if (this.tenantId == '4551453470943235290') {
        this.getWorkType();
      }
      if (!this.orderState || this.orderState == 'archived' || this.orderState == 'concern') {
        this.getSA();
        return;
      }
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        orderState: this.orderState,
        'regex:title|string#or': this.searchValue,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:exts.serviceAppointmentCode|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'regex:describe|string#or': this.searchValue,
        'gte:createTime|date#and': this.searchDate[0],
        'lte:createTime|datetime#and': this.searchDate[1]
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/workOrder/querySAWorkflowNode.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      });
    },
    //查询售后工单列表（非工作流记录）
    getSA() {
      this.searchDate = this.searchDate || [];
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'in:state|integer#and': this.orderState == 'archived' ? -1 : 1,
        'regex:name|string#or': this.searchValue,
        'regex:title|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:exts.serviceAppointmentCode|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'regex:describe|string#or': this.searchValue,
        'gte:createTime|date#and': this.searchDate[0],
        'lte:createTime|datetime#and': this.searchDate[1],
        'in:concernUserIds|array#and': this.orderState == 'concern' ? this.user._id : null,
        notFilterBelongTo: this.orderState == 'concern' ? '1' : null,
        notFilterOrgId: this.orderState == 'concern' ? '1' : null
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/workOrder/query.do', params, res => {
        let data = [];
        res.data.map(item => {
          data.push({
            data: item
          });
        });
        res.data = data;
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
        this.$forceUpdate();
      });
    },
    doEnable(id) {
      this.osg.ajax('basic/workOrder/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/workOrder/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doClose(row) {
      this.osg.confirm(`是否确认关闭工单${row.orderNum}？`, () => {
        this.osg.ajax('/basic/workOrder/forceCloseServiceById.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功！');
        });
      });
    },
    doArchive(row, msg, state) {
      if (this.fillArchiveReason && state == 1) {
        this.$prompt('请输入归档原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: null,
          inputErrorMessage: '归档原因不能为空',
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(({ value }) => {
            debugger;
            this.osg.ajax('basic/workOrder/archive/' + row._id + '.do', { comments: value }, () => {
              this.getData();
              this.osg.toast(`已${msg}售后工单 ${row.title}`);
            });
          })
          .catch(() => {
            //   this.osg.toast('取消审核', 'info');
          });
      } else {
        this.osg.confirm(`是否确认${msg}售后工单 ${row.title}？`, () => {
          this.osg.ajax('basic/workOrder/archive.do', { id: row._id }, () => {
            this.getData();
            this.osg.toast(`已${msg}售后工单 ${row.title}`);
          });
        });
      }
    },
    doNew() {
      this.doInit();
      if (this.tenantId == '4551453470943235290') {
        this.getWorkType('new');
      }
      this.openDetail = true;
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.$refs.formData) {
          this.$refs.form.$refs.formData.clearValidate();
        }
      });
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      row.gpsPoint = row.gpsPoint || {};
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.formData.exts = this.formData.exts || {};
      if (this.tenantId == '4551453470943235290') {
        this.getWorkType('edit');
      }
      // 无手机号返回查看中间号按钮
      if (
        !row.phone &&
        (this.tenantId == '1340835581184723420' ||
          (this.osg.tenantConfig && this.osg.tenantConfig.privateNumber == 1))
      ) {
        this.privateNumber.show = true;
      } else {
        this.privateNumber.show = false;
      }
      this.openDetail = true;
      this.osg.getSubdistricts(this.formData.area, result => {
        this.options.subdistricts = result;
        this.$forceUpdate();
      });
    },
    doSave() {
      if (this.osg.isRepeatClick('saveRecord', 5000)) {
        return;
      }
      if (this.osg.validate()) {
        if (this.osg.isRepeatClick('doSA', 5000)) {
          return;
        }
        var params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }

        this.$util.saveFormatExtField(this.extFields, params);
        this.osg.ajax('basic/workOrder/upsert.do', { data: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //展示分配服务资源
    openSR(row, wf) {
      if (wf) {
        // 重新分派
        this.SR.nodeType = wf.nodeDef.nodeTypeOld || wf.nodeDef.nodeType;
        this.currentWorkflow = wf;
        this.formData = row;
      } else {
        this.SR.nodeType = row.nodeDef.nodeType;
        this.currentWorkflow = row;
        this.formData = row.data;
      }
      //赋值资源类型、资源角色 筛选框
      this.SR.resourceType =
        this.SR.resourceType.length > 0
          ? this.SR.resourceType
          : this.currentWorkflow.nodeDef.resourceType;
      this.SR.resourceRoles =
        this.SR.resourceRoles.length > 0
          ? this.SR.resourceRoles
          : this.currentWorkflow.nodeDef.resourceRoles;
      this.$forceUpdate();

      this.formData.gpsPoint = this.formData.gpsPoint || {};
      this.formData.exts = this.formData.exts || {};
      //获取服务区域 筛选
      this.getServiceTerritory();
      //获取服务资源
      this.getSR();
      this.SR.show = true;
      this.SR.loading = true;
    },
    //获取服务资源
    getSR() {
      let params = {
        page: this.SR.fpi.page || 1,
        rows: this.SR.fpi.rows || 20,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:name|string#and': this.SR.searchValue,
        'in:_id|array#and': this.SR.ids, //按服务区域关联的服务资源筛选
        'in:resourceType|array#and': this.SR.resourceType && this.SR.resourceType.join(),
        'in:resourceRoles|array#and': this.SR.resourceRoles && this.SR.resourceRoles.join()
      };
      //按资源类型过滤
      // if (this.SR.resourceType) {
      //   params['is:resourceType|string#and'] = this.SR.resourceType;
      // } else {
      //   if (this.SR.nodeType == 'allot') {
      //     params['in:resourceType|array#and'] = 'partner,serviceCrew';
      //   } else if (this.SR.nodeType == 'dispatch') {
      //     params['nin:resourceType|array#and'] = 'partner,serviceCrew';
      //   }
      // }
      this.osg.ajax(
        'biz/serviceResource/query.do',
        params,
        async res => {
          //收集服务资源id、组织id、用户id
          let SRIds = [];
          let orgIds = [];
          let userIds = [];
          res.data.map(item => {
            SRIds.push(item._id);
            if (item.resourceType == 'partner' || item.resourceType == 'serviceCrew') {
              //伙伴、班组
              orgIds.push(item.serviceCrewId);
            } else {
              //technician技师、dispatcher派单员
              userIds.push(item.relatedRecordId);
            }
          });

          //获取服务区域、组织、用户 用作返显服务区域和资源名称
          if (SRIds.length > 0) {
            await new Promise(resolve => {
              this.getST(SRIds, resolve);
            });
            if (orgIds.length > 0) {
              await new Promise(resolve => {
                this.getOrgs(orgIds, resolve);
              });
            }
            if (userIds.length > 0) {
              await new Promise(resolve => {
                this.getUsers(userIds, resolve);
              });
            }
          }
          this.SR.fpi = res;
          this.SR.loading = false;
        },
        {
          noload: true
        }
      );
    },
    selectSR(row) {
      if (row) {
        this.SR.selectRow = row;
        this.SR.selectId = row._id;
      }
    },
    saveSR() {
      if (!this.SR.selectId) {
        this.osg.toast('请选择服务资源！', 'warning');
        return;
      }
      let params = {
        smodule: 'workOrder',
        workflowNodeId: this.currentWorkflow._id
      };
      if (
        this.SR.selectRow.resourceType == 'partner' ||
        this.SR.selectRow.resourceType == 'serviceCrew'
      ) {
        params.currentOrgId = this.SR.selectRow.serviceCrewId;
      } else {
        params.handlerId = this.SR.selectRow.relatedRecordId;
      }
      //撤回单
      let msg = this.orderState ? '' : '重新';
      this.osg.confirm(
        `是否确认${msg}${this.currentWorkflow.nodeDef.name}给 ${this.SR.selectRow.name}`,
        () => {
          this.cancelSR();
          if (!this.orderState) {
            //重新分派单
            this.takebackWorkflow(() => {
              this.process(params);
            });
          } else {
            //首次分派单
            this.process(params);
          }
        }
      );
    },
    // 撤回到当前节点
    takebackWorkflow(callback) {
      let params = {
        workflowNodeId: this.currentWorkflow._id,
        smodule: 'workOrder',
        sid: this.formData._id
      };

      this.osg.ajax(
        'workflow/takebackWorkflow.do',
        params,
        () => {
          if (callback) callback();
        },
        { noload: true }
      );
    },
    // 分派
    process(params) {
      this.osg.ajax('workflow/process.do', params, () => {
        this.osg.toast(`${this.currentWorkflow.nodeDef.name}成功`);
        this.getData();
        this.doInit();
      });
    },
    cancelSR() {
      this.SR.show = false;
      this.SR.selectRow = {};
      this.SR.selectId = '';
      this.SR.searchValue = '';
      this.SR.resourceType = []; //筛选服务资源类型
      this.SR.resourceRoles = []; //筛选资源角色
    },
    // 接单
    accept(row) {
      this.osg.confirm(`“${row.data.title}”，是否确认接单？`, () => {
        this.currentWorkflow = row;
        let params = {
          smodule: 'workOrder',
          workflowNodeId: row._id,
          handlerId: this.user._id
        };
        this.process(params);
      });
    },
    //获取所有服务区域支持搜索
    getServiceTerritory(query) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'regex:name|string#and': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = (item.relatedIds && item.relatedIds.join()) || ' ';
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //获取当前服务资源列表所属的服务区域 返显
    getST(SRIds, resolve) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          // page: 1,
          // rows: SRIds.length,
          _all: '1',
          'in:relatedIds|array#and': SRIds.join(),
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item.relatedIds;
          });
          this.options.ST = res.data;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    //获取组织
    getOrgs(orgIds, resolve) {
      this.osg.ajax(
        'org/query.do',
        {
          page: 1,
          rows: orgIds.length,
          'in:_id|array#and': orgIds.join()
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.org = res.data.orgList;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    // 服务资源列表返显用户名称
    getUsers(userIds, resolve) {
      this.osg.ajax(
        'user/query.do',
        {
          page: 1,
          rows: userIds.length,
          'in:_id|array#and': userIds && userIds.join()
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          resolve();
        },
        {
          noload: true
        }
      );
    },
    //表格刷新
    Refresh() {
      this.refresh = false;
      this.$nextTick(function() {
        this.refresh = true;
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.$forceUpdate();
        });
      }
    },
    //获取工作类型
    getWorkType(type) {
      let params = {
        page: 1,
        _all: '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      switch (type) {
        case 'new': //新建只允许选择启用状态的workType
          params['is:state|integer#or'] = 1;
          break;
        case 'edit': //编辑只允许选择启用状态的workType 和 展示当前已选择的（防止之前选择的被禁用无法正常展示）
          params['is:state|integer#or'] = 1;
          params['is:_id|string#or'] = this.formData.workType;
          break;
        default:
        //用作formater渲染 查询所有状态的
      }
      this.osg.ajax(
        'biz/workType/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.workType = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    //判断是否展示重新分派下拉菜单
    btnShow(data) {
      var { workflowNodeList } = data;
      if (
        workflowNodeList[workflowNodeList.length - 1] &&
        workflowNodeList[workflowNodeList.length - 1].state == 10
      )
        return false;
      let createUser = data.createUser;
      for (var i = 1; i < workflowNodeList.length; i++) {
        if (this.available(workflowNodeList[i], createUser)) {
          return true;
        }
      }
      return false;
    },
    //用于扩展字段，判断如果配置了因为某个字段值才显示
    isShowField(obj, key, showField, showValue) {
      if (
        obj[showField] &&
        (obj[showField] == showValue || Array.isArray(obj[showField])
          ? obj[showField].flat().indexOf(showValue) !== -1
          : obj[showField].indexOf(showValue) !== -1)
      )
        return true;

      obj.exts = obj.exts || {};
      if (
        obj.exts[showField] &&
        (obj.exts[showField] == showValue || Array.isArray(obj.exts[showField])
          ? obj.exts[showField].flat().indexOf(showValue) !== -1
          : obj.exts[showField].indexOf(showValue) !== -1)
      )
        return true;
    },
    // 判断当前登录用户是否可操作重新分派
    available(workflowNode, createUser) {
      if (
        workflowNode.state == 10 &&
        (workflowNode.nodeDef.nodeTypeOld == 'allot' ||
          workflowNode.nodeDef.nodeType == 'allot' ||
          workflowNode.nodeDef.nodeTypeOld == 'dispatch' ||
          workflowNode.nodeDef.nodeType == 'dispatch')
      ) {
        var { userChooseRule, userChoose } = workflowNode.nodeDef;
        if (userChooseRule == 'starter') {
          // 发起人
          if (this.accountIds.indexOf(createUser) != -1) {
            return true;
          } else {
            return false;
          }
        } else {
          for (var id of userChoose) {
            if (this.accountIds.indexOf(id) != -1) {
              return true;
            }
          }
          return false;
        }
      } else {
        return false;
      }
    },
    //查看通话记录
    viewCallRecord(callId) {
      this.osg.ajax(
        'basic/sobot/queryByCallId.do',
        {
          callId
        },
        res => {
          this.callRecording = true;
          this.callRecordingData = res.data;
          //   if (res.data)
          //     this.callRecordingData = res.data;
          //     this.record.openCallRecord = true;
          //   }
        },
        { noload: true }
      );
    },
    /**
     * 外呼
     */
    callOut(_id) {
      // 调用外呼接口-传外呼号码
      // this.osg.sobot.callOut({
      //   destinationNumber: row.data.phone,
      //   params: `{ "bizType": "workOrder","bizId":"${row.data._id}"}`
      // });
      this.$router.push({
        path: `/Flow/workOrder/${_id}`,
        query: { isCall: true }
      });
    },
    /**
     * 数据导出(通过传表头数据方式实现),售后工单专用版
     */
    doExportSA(params) {
      let paramObj = {};
      let searchObj = {};
      //如有调整，售后工单导出使用的是单独个方法，需要去售后工单也进行修改!
      if (window.$that) {
        window.$that.getParams(params);
      }
      for (let paramKey in params) {
        //给查询条件 去掉fpi-
        if (paramKey.indexOf('|') != -1 || paramKey == 'sortField' || paramKey == 'sortOrder') {
          searchObj[paramKey.replace('fpi-', '')] = params[paramKey];
        } else {
          paramObj[paramKey] = params[paramKey];
        }
      }
      let headerList = []; //表头数据
      //   this.extFields.forEach(el => {
      //     if (el.showList && el.showList.includes('1')) {
      //       let obj = {};
      //       obj[el.nameDisp] = el.name;
      //       headerList.push(obj);
      //     }
      //     // let obj = {};
      //     //     obj[el.label] = el.prop && el.prop.replace('data.', '').replace('exts.', '');
      //     //     if (el.label || el.prop) headerList.push(obj);
      //   });
      this.$refs.table.$children.forEach(el => {
        let obj = {};
        obj[el.label] = el.prop && el.prop.replace('data.', '').replace('exts.', '');
        if (el.label || el.prop) headerList.push(obj);
      });
      if (!paramObj.beanName) paramObj.beanName = window.$this.name; //表格名
      if (!paramObj.title) paramObj.title = window.$this.name; //
      let jsonList = []; //生成文件名
      for (let pKey in paramObj) {
        let obj = {};
        obj[pKey] = paramObj[pKey];
        if (pKey) jsonList.push(obj);
      }
      jsonList = jsonList.concat(headerList);
      this.osg.ajax(
        'excel/export.do',
        Object.assign(searchObj, {
          jsonList: JSON.stringify(jsonList)
        }),
        res => {
          // 对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
          let temp = res.headers['content-disposition'].split('=')[1];
          let iconv = require('iconv-lite');
          iconv.skipDecodeWarning = true; //忽略警告
          let fileName = iconv.decode(temp, 'gbk');
          const _res = res.data;
          let blob = new Blob([_res]);
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        },
        {
          responseType: 'blob'
        }
      );
    },
    //保存催办售后工单
    saveAlert() {
      var params = this.workflowAlertData;
      if (this.callId) params.callId = this.callId;

      this.osg.ajax('/biz/workflowAlert/upsert.do', params, () => {
        this.sendAlert();
        this.osg.toast('保存成功！');
        this.$emit('delCallId', true);
      });
    },
    //新增催办售后工单弹出页面
    readyAlert(row) {
      let creatorId = row.createUser;
      let workflowId = row.workflowId;
      let tenantId = row.tenantId;
      this.workflowAlertData.workflowId = workflowId;
      this.osg.ajax('/workflow/getTodoNodes.do', { tenantId, workflowId }, res => {
        this.workflowAlertData.workflowNodeId = res._id;
        if (res.userChooseRule && res.userChooseRule.startsWith('role')) {
          let roleIds = res.userChooseRule.replace('role:', '').split(',');
          let roleParam = {
            _all: '1',
            'in:roleIds|array#and': roleIds.join(','),
            'is:state|integer#and': 1
          };
          this.osg.ajax('user/query.do', roleParam, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = res.data.map(item => item._id);
            this.workflowAlert = true;
          });
        } else if (res.userChooseRule && res.userChooseRule.startsWith('orgrole')) {
          let roleIds = res.userChooseRule.replace('orgrole:', '').split(',');
          let orgIds = res.handlerIds.map(item => item.split('+')[0]);
          let orgParams = {
            _all: '1',
            'in:orgIds|array#and': orgIds.join(','),
            'in:roleIds|array#and': roleIds.join(','),
            'is:state|integer#and': 1
          };
          this.osg.ajax('user/query.do', orgParams, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = res.data.map(item => item._id);
            this.workflowAlert = true;
          });
        } else if (res.userChooseRule && res.userChooseRule.startsWith('starter')) {
          let startParams = {
            'is:state|integer#and': 1,
            'is:_id|String#and': creatorId
          };
          this.osg.ajax(`user/find/${creatorId}.do`, startParams, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = [res.data._id];
            this.workflowAlert = true;
          });
        } else {
          let userIds = res.handlerIds;
          let userParams = {
            _all: '1',
            'in:_id|array#and': userIds,
            'is:state|integer#and': 1
          };
          this.osg.ajax('user/query.do', userParams, res => {
            this.alertUser = res.data;
            this.workflowAlertData.handlerIds = res.data.map(item => item._id);
            this.workflowAlert = true;
          });
        }
      });
      this.alertMsgList(row);
      this.workflowAlertData.type = 1;
    },
    //控制催办弹出页面
    sendAlert() {
      this.workflowAlert = false;
      //this.workflowAlertData = {};
    },
    alertMsgList(sa) {
      let param = {
        page: this.workflowAlerFpi.page || 1,
        rows: this.workflowAlerFpi.rows || 10,
        'is:workflowId|string#and': sa.workflowId
      };
      this.osg.ajax('biz/workflowAlert/query.do', param, res => {
        if (res.data) {
          this.alertTableData = res.data;
          let handles = res.data.map(item => item.handleUserId);
          this.osg.ajax(
            'user/query.do',
            {
              _all: '1',
              'in:_id|array#and': handles
            },
            res => {
              var names = {};
              res.data.forEach(item => {
                names[item._id] = item.name;
              });
              for (var i = 0; i < this.alertTableData.length; i++) {
                let uId = this.alertTableData[i].handleUserId;
                // if (names[uId]) {
                //   this.alertTableData[i].handleUserName = names[uId];
                // } else {
                //   this.alertTableData[i].handleUserName = '';
                // }
                names[uId] ? (this.alertTableData[i].handleUserName = names[uId]) : '';
              }
              this.$forceUpdate();
            }
          );
        }
      });
    },
    formatType1Type(row, column, cellValue) {
      if (cellValue || cellValue === 0) {
        return this.osg.codelabel('workflowAlert', cellValue);
      }
    },
    formatAltertState(row, column, cellValue) {
      if (cellValue || cellValue === 0) {
        return this.osg.codelabel('altertState', cellValue);
      }
    },
    getChannel() {
      this.osg.ajax(
        'channel/query.do',
        {
          _all: '1',
          'is:state|integer#and': '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.channelId = res.data;
          this.$forceUpdate();
        }
      );
    },
    //获取质保卡库存
    getWarrantyProductInventorys(phone) {
      //选择字典表选项
      this.$set(this.formData.exts, 'inventoryId', ''); //质保卡库存id
      this.$set(this.formData.exts, 'inventoryCode', ''); //质保卡库存编号
      this.$set(this.formData.exts, 'warrantyProductName', ''); //质保卡库存名称
      this.$set(this.formData.exts, 'wpiOrgId', ''); //质保卡关联的orgid
      this.$set(this.formData.exts, 'warrantyProductProductList', ''); //激活质保卡库存选择的防水产品
      delete this.formData.exts.bdBucketCodes; //清空产品码
      if (phone.length == '11') {
        var params = {
          // page: 1,
          // rows: 50,
          _all: 1,
          'is:status|integer#and': '3',
          'is:state|integer#and': '1',
          'is:customerPhone|string#and': phone
          // sortField: 'createTime',
          // sortOrder: 'desc',
          // notFilterOrgId: '1',
          // notFilterBelongTo: '1'
        };
        this.osg.ajax('basic/warrantyProductInventory/query.do', params, res => {
          if (res.data) {
            this.$set(
              this.options,
              'warrantyProductInventorys',
              res.data.map(item => {
                item.label = item.warrantyProductName;
                item.name = item.warrantyProductName;
                item.value = item._id;
                return item;
              })
            );
            this.$forceUpdate();
          }
        });
      } else {
        this.$set(this.options, 'warrantyProductInventorys', []);
      }
    },
    //选择质保卡
    handleInventoryIdSelect(value) {
      let row = this.$util.deepCopy(
        this.options.warrantyProductInventorys.find(item => item._id == value)
      );
      //选择字典表选项
      this.$set(this.formData.exts, 'inventoryId', row.value); //质保卡库存id
      this.$set(this.formData.exts, 'inventoryCode', row.inventoryCode); //质保卡库存编号
      this.$set(this.formData.exts, 'warrantyProductName', row.warrantyProductName); //质保卡库存名称
      this.$set(this.formData.exts, 'wpiOrgId', row.orgId); //质保卡关联的orgid

      this.$set(this.formData, 'area', row.exts.area); //省市区
      if (row.exts.area.length >= 1) {
        this.$set(this.formData, 'province', row.exts.area[0]);
      }
      if (row.exts.area.length >= 2) {
        this.$set(this.formData, 'city', row.exts.area[1]);
      }
      if (row.exts.area.length >= 3) {
        this.$set(this.formData, 'district', row.exts.area[2]);
      }
      this.$set(this.formData, 'name', row.customerName); //业主名称
      this.changeName(row.customerName); //赋值售后工单标题
      this.$set(this.formData, 'phone', row.customerPhone); //业主手机号
      this.$set(this.formData, 'address', row.exts.address); //详细地址
      this.$set(this.formData, 'applyTime', row.exts.applyTime); //预约时间
      this.$set(this.formData.exts, 'certificateType', row.exts.certificateType); //证件类型
      this.$set(this.formData.exts, 'certificateNum', row.exts.certificateNum); //证件号
      this.$set(
        this.formData.exts,
        'warrantyProductProductList',
        row.exts.warrantyProductProductList
      ); //激活质保卡库存选择的防水产品
      delete this.formData.exts.bdBucketCodes; //清空产品码
    },
    //TODO: 新增报单产品码
    addBdBucketCodes() {
      let extField = this.extFields.find(fiel => fiel.name == 'title21');
      let options = extField.frontEndConfig;
      let field = 'title21';
      if (!this.formData.exts[field]) {
        this.osg.toast('不允许添加空值！', 'warning');
        return;
      }

      let url = options.url + this.formData.exts[field];
      //如果有url校验
      if (options.funcUrl) {
        //小程序、h5分别调用接口不同
        let httpUrl = '';
        // #ifdef H5
        // httpUrl = options.funcH5Url;
        // #endif
        // #ifdef MP-WEIXIN
        httpUrl = options.funcUrl;
        // #endif
        let keyField = options.key;
        let sortField = options.sortField;
        this.osg.ajax(
          httpUrl,
          {
            url,
            inventoryId: this.formData.exts.inventoryId || '',
            productCodeList:
              this.formData.exts.bdBucketCodes &&
              Object.keys(this.formData.exts.bdBucketCodes).join(',')
          },
          res => {
            if (sortField) {
              //按分类统计展示
              let obj = this.formData.exts[sortField] || {};
              let result = res.data;
              let key = result[keyField];
              obj[key] = obj[key] || [];
              if (obj[key].indexOf(url) != -1) {
                this.osg.toast('重复扫码', 'none');
                return;
              } else {
                obj[key].push(url);
              }
              this.formData.exts[sortField] = obj;
              console.log(this.formData.exts[sortField]);

              this.osg.toast('添加成功');
              if (options.clear) {
                this.formData.exts[field] = '';
              }
              this.$forceUpdate();
            } else {
              // 不按分类统计的情况
              this.formData.exts[sortField].push(url);
              this.$forceUpdate();
            }
          }
        );
      } else {
        // 不按分类统计的情况
        this.formData.exts[field].push(url);
        this.$forceUpdate();
      }
    },
    //TODO: 删除报单产品码
    bdPCodeDelete(item, iIndex, row, key) {
      this.osg.confirm('是否确认删除？', () => {
        console.log(item, iIndex, row, key);
        item.splice(iIndex, 1);
        if (!item.length) delete row[key];
        this.$forceUpdate();
        console.log(item, iIndex, row, key);
      });
    },
    selectionChange(rows) {
      this.selectedList = rows;
    },
    batchExpurgate() {
      var data = this.selectedList;
      if (data.length > 0) {
        var workOrderIds = [];
        data.forEach(item => workOrderIds.push(item.data._id));
        workOrderIds = workOrderIds.join(',');
        console.log(JSON.stringify(workOrderIds));
        let params = {
          workOrderIds: workOrderIds
        };
        this.osg.ajax('basic/workOrder/batchArchive.do', params, response => {
          if (response.success == false) {
            this.$message.error(response.message);
          }
          if (response.success == true) {
            this.$message.info('操作成功');
            this.getSA();
          }
        });
      } else {
        this.$message.error('未选择工单数据');
      }
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.orderState = this.osg.param('orderState');
      this.osg.getFpi();
      this.doInit();
      if (this.serviceState) {
        if (this.$route.params.searchValue) {
          this.searchValue = this.$route.params.searchValue;
        }
      }
      // this.getData();
      this.Refresh();
    },
    //area 级联组件点击label就消失
    'formData.area'() {
      if (this.$refs.areaSelector) {
        this.$refs.areaSelector.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //手机号发生改变
    'formData.phone'(val) {
      if (this.tenantId == '4551453470943235290') this.getWarrantyProductInventorys(val);
    }
  }
};
</script>
<style>
.workOrders .c-dialog {
  min-width: 1000px !important;
}
.bdPCode-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #f2f2f2;
  padding: 4px;
  box-sizing: border-box;
  margin-top: -1px;
}
</style>
